<template>
    <!-- Don't drop "q-app" class -->
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    /*
     * Root component
     */
    export default {
        name: 'app'
    };
</script>

<style></style>


// WEBPACK FOOTER //
// resources/assets/js/App.vue